import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M10 17.5H21M6.5 12H17.5M3 6.5H14" strokeLinejoin="round" />
	</SVG>
);
